import {
  BOOLEAN_FACETS_MAPPING_VALUE,
  CATEGORY_SPECIFIC_FACETS_ALGOLIA,
} from 'components/SA/Facets/helpers/constants'
import { getParamsToGenerateURL } from '../../selectors/facets'
import { generateLocationUrl } from 'components/SA/Facets/helpers/url'
import { getSelectedFacets } from 'selectors/algolia2/data'

export const getHrefFunction = (state) => {
  const { queryParams, pathParams, sharedFacetNames } = getParamsToGenerateURL(state)
  const selectedFacets = getSelectedFacets(state)

  // We want a way to create pass in PARAMS and create UNIQUE url
  return (params): string => {
    let updatedParams = { ...queryParams, ...(params || {}) }

    // Clear category-specific facets when category changes
    if (params?.category) {
      const newCategory = Array.isArray(params.category) ? params.category[0] : params.category
      const oldCategory = selectedFacets?.category?.[0]

      if (newCategory !== oldCategory && oldCategory) {
        const facetsToClear = CATEGORY_SPECIFIC_FACETS_ALGOLIA[oldCategory] || []

        facetsToClear.forEach((facet) => {
          updatedParams[facet] = []
        })
      }
    }

    return generateLocationUrl({
      queryParams: updatedParams,
      // Params are OVERRIDES to create URL
      pathParams,
      sharedFacetNames,
      booleanFacetsObject: BOOLEAN_FACETS_MAPPING_VALUE,
    })
  }
}
